module.exports = __webpack_public_path__ + "img/logo_new.8f94c0d6.png";